import { NgModule } from '@angular/core';
import { SessionWarningComponent } from './session-warning/session-warning.component';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { AcIconArrowDownComponent } from './ac-icon-arrow-down/ac-icon-arrow-down.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BasicSelectComponent } from './basic-select/basic-select.component';
import { AcIconArrowRightComponent } from './ac-icon-arrow-right/ac-icon-arrow-right.component';
import { ValidationMessageComponent } from './validation-message/validation-message.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { PaginationSelectComponent } from './pagination-select/pagination-select.component';
import { SafePipe } from '../core/pipes/safe.pipe';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { OptionalLabelComponent } from './optional-label/optional-label.component';
import { ContentModalComponent } from './content-modal/content-modal.component';
import { CustomMultiSelectComponent } from './custom-multi-select/custom-multi-select.component';
import { TruncatePipe } from '../core/pipes/truncate.pipe';
import { DateAgoPipe } from '../core/pipes/date-ago.pipe';
import { LineBreakReplacePipe } from '../core/pipes/line-break-replace.pipe';
import { PageLoadingOverlayComponent } from './page-loading-overlay/page-loading-overlay.component';
import { LoadingGifImageComponent } from './loading-gif-image/loading-gif-image.component';
import { MarkdownPipe } from '../core/pipes/markdown.pipe';
import { PermissionDirective } from '../core/directives/permission.directive';
import { ExchangeRatePermissionDirective } from '../core/directives/exchange-rate-permission.directive';
import { ExchangeRateFlatDirective } from '../core/directives/exchange-rate-flat.directive';
import { DefaultCurrencyPipe } from '../core/pipes/default-currency.pipe';
import { LoadingModalComponent } from './loading-modal/loading-modal.component';
import { LoadingOverlayFullComponent } from './loading-overlay-full/loading-overlay-full.component';
import { GuestHeaderComponent } from './guest-header/guest-header.component';
import { ExchangeRateFieldComponent } from './exchange-rate-field/exchange-rate-field.component';
import { SplitByCapitalPipe } from '../core/pipes/split-by-capital.pipe';
import { FilterAndSortActionButtonsComponent } from './filter-and-sort-action-buttons/filter-and-sort-action-buttons.component';
import { ToastComponent } from './toast/toast.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TermsModalComponent } from './terms-modal/terms-modal.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { EnterPasswordModalComponent } from './enter-password-modal/enter-password-modal.component';
import { RequiredLabelComponent } from './required-label/required-label.component';
import { StatusBadgePipe } from '../core/pipes/status-badge.pipe';
import { CaretIconComponent } from './caret-icon/caret-icon.component';
import { FormatNullableTextPipe } from '../core/pipes/format-nullable-text.pipe';
import { TagsInputComponent } from './tags-input/tags-input.component';
import { DisablePasteDirective } from '../core/directives/disable-paste.directive';
import { FilePreviewBtnComponent } from './file-preview-btn/file-preview-btn.component';
import { YesOrNoTextPipe } from '../core/pipes/yes-or-no-text.pipe';
import { ModalLoadingOverlayComponent } from './modal-loading-overlay/modal-loading-overlay.component';
import { ModalLoadingOverlayCloseComponent } from './modal-loading-overlay-close/modal-loading-overlay-close.component';
import { TitleCasePipe } from '../core/pipes/title-case.pipe';
import { PadLeftPipe } from '../core/pipes/pad-left.pipe';
import { ColorDivComponent } from './color-div/color-div.component';
import { CustomSearchWidgetComponent } from './custom-search-widget/custom-search-widget.component';
import { Icd10InputComponent } from './icd10-input/icd10-input.component';
import { DisableElementDirective } from '../core/directives/disable-element.directive';
import { ConditionalBackgroundColorDirective } from '../core/directives/conditional-background-color.directive';
import { ImageSelectInputComponent } from './image-select-input/image-select-input.component';
import { CustomCurrencyPipe } from '../core/pipes/custom-currency.pipe';
import { PercentageBasedBgPipe } from '../core/pipes/percentage-based-bg.pipe';
import { FileDownloadPathPipe } from '../core/pipes/file-download-path.pipe';
import { CustomDatePickerComponent } from './custom-date-picker/custom-date-picker.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { FeatureIconComponent } from './feature-icon/feature-icon.component';
import { SearchIcd10CodeComponent } from './search-icd10-code/search-icd10-code.component';
import { SearchTariffCodeComponent } from './search-tariff-code/search-tariff-code.component';
import { TariffInputComponent } from './tariff-input/tariff-input.component';
import { SearchCompanyComponent } from './search-company/search-company.component';
import { AffiliationDirective } from '../core/directives/affiliation.directive';
import { AgePipe } from '../core/pipes/age.pipe';
import { TaskInfoComponent } from './task-info/task-info.component';
import { CustomTrueFalseComponent } from './custom-true-false/custom-true-false.component';
import { SearchProviderComponent } from './search-provider/search-provider.component';
import { StaticProgressBarComponent } from './static-progress-bar/static-progress-bar.component';
import { SearchModifierComponent } from './search-modifier/search-modifier.component';
import { ModifierInputComponent } from './modifier-input/modifier-input.component';
import { WebcamModule } from 'ngx-webcam';
import { MemberFaceVerificationComponent } from './member-face-verification/member-face-verification.component';
import { TakeMemberPhotoComponent } from './take-member-photo/take-member-photo.component';
import { MemberOtpVerificationComponent } from './member-otp-verification/member-otp-verification.component';
import { DomainDirective } from '../core/directives/domain.directive';
import { ReportsIndexListItemComponent } from './reports-index-list-item/reports-index-list-item.component';
import { LocationInputComponent } from './location-input/location-input.component';
import { PlacePickerModule } from 'ngx-place-picker';
import { SearchAgentGroupComponent } from './search-agent-group/search-agent-group.component';
import { SearchServiceTypeComponent } from './search-service-type/search-service-type.component';
import { InvoiceItemsTableComponent } from './invoice-items-table/invoice-items-table.component';
// Declared here rather than in the member PagesModule because it has consumers in more than
// one module (the member dashboard rail). Importing PagesModule elsewhere would drag
// PagesRoutingModule's routes along with it. Atenza declares it in its SharedModule too.
import { MemberMembershipCardComponent } from 'src/app/portals/member/pages/membership-card/membership-card.component';

@NgModule({
  declarations: [
    MemberMembershipCardComponent,
    SessionWarningComponent,
    CustomSelectComponent,
    AcIconArrowDownComponent,
    BasicSelectComponent,
    AcIconArrowRightComponent,
    ValidationMessageComponent,
    MessageModalComponent,
    LoadingOverlayComponent,
    PaginationSelectComponent,
    SafePipe,
    PermissionDirective,
    ExchangeRatePermissionDirective,
    DisableElementDirective,
    ConditionalBackgroundColorDirective,
    ExchangeRateFlatDirective,
    AffiliationDirective,
    DefaultCurrencyPipe,
    DomainDirective,
    TruncatePipe,
    MarkdownPipe,
    AgePipe,
    DateAgoPipe,
    TitleCasePipe,
    StatusBadgePipe,
    PadLeftPipe,
    FormatNullableTextPipe,
    SplitByCapitalPipe,
    LineBreakReplacePipe,
    SearchProviderComponent,
    SearchAgentGroupComponent,
    ConfirmModalComponent,
    MemberFaceVerificationComponent,
    MemberOtpVerificationComponent,
    TakeMemberPhotoComponent,
    OptionalLabelComponent,
    ContentModalComponent,
    CustomMultiSelectComponent,
    PageLoadingOverlayComponent,
    LoadingGifImageComponent,
    LoadingModalComponent,
    GuestHeaderComponent,
    LoadingOverlayFullComponent,
    ExchangeRateFieldComponent,
    FilterAndSortActionButtonsComponent,
    ConditionalBackgroundColorDirective,
    ToastComponent,
    SpinnerComponent,
    TermsModalComponent,
    EnterPasswordModalComponent,
    RequiredLabelComponent,
    CaretIconComponent,
    TagsInputComponent,
    DisablePasteDirective,
    FilePreviewBtnComponent,
    YesOrNoTextPipe,
    ModalLoadingOverlayComponent,
    ModalLoadingOverlayCloseComponent,
    ColorDivComponent,
    CustomCurrencyPipe,
    CustomSearchWidgetComponent,
    Icd10InputComponent,
    ModifierInputComponent,
    TariffInputComponent,
    ImageSelectInputComponent,
    PercentageBasedBgPipe,
    FileDownloadPathPipe,
    CustomDatePickerComponent,
    SvgIconComponent,
    FeatureIconComponent,
    SearchIcd10CodeComponent,
    SearchServiceTypeComponent,
    SearchModifierComponent,
    TaskInfoComponent,
    LocationInputComponent,
    ReportsIndexListItemComponent,
    SearchCompanyComponent,
    SearchTariffCodeComponent,
    CustomTrueFalseComponent,
    StaticProgressBarComponent,
    InvoiceItemsTableComponent,
  ],

  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    PlacePickerModule,
    WebcamModule,
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
  ],

  exports: [
    MemberMembershipCardComponent,
    SessionWarningComponent,
    NgbModule,
    CustomSelectComponent,
    BasicSelectComponent,
    AcIconArrowDownComponent,
    ValidationMessageComponent,
    LoadingOverlayComponent,
    FormsModule,
    TruncatePipe,
    MarkdownPipe,
    SafePipe,
    TitleCasePipe,
    PadLeftPipe,
    StatusBadgePipe,
    SplitByCapitalPipe,
    FormatNullableTextPipe,
    LineBreakReplacePipe,
    AgePipe,
    DateAgoPipe,
    CustomCurrencyPipe,
    PermissionDirective,
    ExchangeRatePermissionDirective,
    ExchangeRateFlatDirective,
    PlacePickerModule,
    DefaultCurrencyPipe,
    TaskInfoComponent,
    ReactiveFormsModule,
    MemberFaceVerificationComponent,
    TakeMemberPhotoComponent,
    MemberOtpVerificationComponent,
    SearchProviderComponent,
    SearchAgentGroupComponent,
    DomainDirective,
    ToastComponent,
    WebcamModule,
    PaginationSelectComponent,
    OptionalLabelComponent,
    RequiredLabelComponent,
    ContentModalComponent,
    CustomMultiSelectComponent,
    LoadingGifImageComponent,
    PageLoadingOverlayComponent,
    LoadingModalComponent,
    GuestHeaderComponent,
    LoadingOverlayFullComponent,
    FilterAndSortActionButtonsComponent,
    ExchangeRateFieldComponent,
    TermsModalComponent,
    SpinnerComponent,
    EnterPasswordModalComponent,
    NgxExtendedPdfViewerModule,
    CaretIconComponent,
    TagsInputComponent,
    DisablePasteDirective,
    YesOrNoTextPipe,
    FilePreviewBtnComponent,
    ModalLoadingOverlayComponent,
    ColorDivComponent,
    ReportsIndexListItemComponent,
    CustomSearchWidgetComponent,
    Icd10InputComponent,
    ModifierInputComponent,
    SearchModifierComponent,
    TariffInputComponent,
    DisableElementDirective,
    ImageSelectInputComponent,
    PercentageBasedBgPipe,
    AffiliationDirective,
    FileDownloadPathPipe,
    CustomDatePickerComponent,
    SvgIconComponent,
    StaticProgressBarComponent,
    FeatureIconComponent,
    LocationInputComponent,
    SearchIcd10CodeComponent,
    SearchServiceTypeComponent,
    SearchCompanyComponent,
    SearchTariffCodeComponent,
    CustomTrueFalseComponent,
    InvoiceItemsTableComponent,
  ],
})
export class SharedModule { }
